import { CcfBox, CcfTextField, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './simulator-v2-customer-details-tab.module.scss';
import { DropDown, generateDate } from '../../utils/utils';

/* eslint-disable-next-line */
export interface SimulatorV2CustomerDetailsTabProps {
  setUpdatedContact: any;
  updatedContact: any;
}

/**
 * used to show the Customer Details Tab
 * @param props - SimulatorV2CustomerDetailsTabProps
 * @example ` <SimulatorV2CustomerDetailsTab />`
 */
export function SimulatorV2CustomerDetailsTab(
  props: SimulatorV2CustomerDetailsTabProps
) {
  const { setUpdatedContact, updatedContact } = props;

  /**
   *
   * @param state -
   * @param action -
   * @example
   * @returns
   */
  const handleInputChange = (field: string, value: any) => {
    const currentContact = JSON.parse(JSON.stringify(updatedContact));
    const addressFields = [
      'customerPrimaryAddress.address1',
      'customerPrimaryAddress.address2',
      'customerPrimaryAddress.city',
      'customerPrimaryAddress.state',
      'customerPrimaryAddress.zip',
      'customerPrimaryAddress.country',
    ];
    const customerFields = [
      'firstName',
      'middleName',
      'lastName',
      'phoneNo',
      'replywithApproval',
      'twitterId',
      'emailId',
    ];

    const othersGuarantorDetails: { [key: string]: string } = {
      firstName: 'guarantorFirstName',
      lastName: 'guarantorLastName',
    };
    const currentUpdatedContact = customerFields.includes(field)
      ? {
          ...currentContact,
          customer: {
            ...currentContact.customer,
            [field.substring(field.lastIndexOf('.') + 1)]: value,
            others: {
              ...currentContact.customer.others,
              ...(['firstName', 'lastName'].includes(field)
                ? { [othersGuarantorDetails[field]]: value }
                : {}),
            },
          },
        }
      : addressFields.includes(field)
      ? {
          ...currentContact,
          customer: {
            ...currentContact.customer,
            customerPrimaryAddress: {
              ...currentContact.customer.customerPrimaryAddress,
              [field.substring(field.lastIndexOf('.') + 1)]: value,
            },
            customerSecondaryAddress: {
              ...currentContact.customer.customerSecondaryAddress,
              [field.substring(field.lastIndexOf('.') + 1)]: value,
            },
          },
        }
      : { ...currentContact, [field]: value };

    // if (field === 'channel' && value === 'Email') {
    //   currentUpdatedContact.contactButtons = [contactButtons.commit];
    //   currentUpdatedContact.messageType = 'Email';
    //   currentUpdatedContact.queueName =
    //     'RE: Where is my refund? i cannot beleive';
    // } else if (field === 'media' && value === 'Digital') {
    //   currentUpdatedContact.channel = 'Email';
    // } else if (
    //   (field === 'customerChatReply' ||
    //     field === 'customerChatReplyJsonData' ||
    //     (field === 'channel' && value === 'Chat')) &&
    //   currentUpdatedContact.media !== 'Voice'
    // ) {
    //   currentUpdatedContact.contactButtons = [contactButtons.commit];
    //   currentUpdatedContact.messageType = 'Chat';
    //   currentUpdatedContact.queueName = '';
    // } else {
    //   if (currentUpdatedContact.media === 'Digital') {
    //     if (
    //       field === 'channel' &&
    //       value === 'Chat' &&
    //       currentUpdatedContact?.copilotAssist === 'Yes'
    //     ) {
    //       currentUpdatedContact.contactButtons = [
    //         contactButtons.cobrowsing,
    //         contactButtons.commit,
    //         contactButtons.location,
    //       ];
    //       currentUpdatedContact.messageType = 'Chat';
    //       currentUpdatedContact.queueName = 'VIP Client';
    //     } else {
    //       currentUpdatedContact.messageType = 'Post';
    //       currentUpdatedContact.queueName = 'Mention';
    //     }
    //   }
    // }
    // if (currentUpdatedContact.media === 'Voice') {
    //   currentUpdatedContact.mediaType = 'Voice';
    //   currentUpdatedContact.messageType = '253-895-8956';
    //   currentUpdatedContact.queueName = 'Cust. Service Request';
    //   currentUpdatedContact.contactButtons = [
    //     contactButtons.hold,
    //     contactButtons.mask,
    //     contactButtons.mute,
    //     contactButtons.keypad,
    //     contactButtons.transfer,
    //     contactButtons.record,
    //     //contactButtons.commit,
    //     contactButtons.hungup,
    //   ];
    // } else if (currentUpdatedContact.media === 'Digital') {
    //   currentUpdatedContact.mediaType = 'Digital';
    //   currentUpdatedContact.contactButtons = [
    //     contactButtons.transfer,
    //     contactButtons.commit,
    //   ];
    // } else if (currentUpdatedContact.media === 'VideoCall') {
    //   currentUpdatedContact.mediaType = 'VideoCall';
    //   currentUpdatedContact.channel = 'VideoCall';
    //   currentUpdatedContact.messageType = 'VideoCall';
    //   currentUpdatedContact.queueName = 'Damaged Luggage';
    // }
    // currentContact = currentUpdatedContact;

    // console.log('Updated contact in handleInputChange:', currentContact);
    // // setUpdatedContact(currentContact);
    setUpdatedContact({
      ...currentUpdatedContact,
      lastUpdatedDate: generateDate(),
    });
  };

  return (
    <div className={styles['container']}>
      <CcfBox style={{ padding: '20px', paddingBottom: '0px' }}>
        <CcfTypography className={styles.headerText}>
          Customer Details
        </CcfTypography>

        <CcfBox
          style={{
            margin: '15px 0px 0px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '20px',
          }}
        >
          {[
            {
              label: 'FIRST NAME',
              field: 'firstName',
              value: updatedContact.customer?.firstName,
              required: true,
            },
            {
              label: 'MIDDLE NAME',
              field: 'middleName',
              value: updatedContact.customer?.middleName,
            },
            {
              label: 'LAST NAME',
              field: 'lastName',
              value: updatedContact.customer?.lastName,
              required: true,
            },
            {
              label: 'ADDRESS LINE 1',
              field: 'customerPrimaryAddress.address1',
              value: updatedContact.customer?.customerPrimaryAddress?.address1,
            },
            {
              label: 'ADDRESS LINE 2',
              field: 'customerPrimaryAddress.address2',
              value: updatedContact.customer?.customerPrimaryAddress?.address2,
            },
            {
              label: 'COUNTRY',
              field: 'customerPrimaryAddress.country',
              value: updatedContact.customer?.customerPrimaryAddress?.country,
            },
            {
              label: 'STATE',
              field: 'customerPrimaryAddress.state',
              value: updatedContact.customer?.customerPrimaryAddress?.state,
            },
            {
              label: 'CITY',
              field: 'customerPrimaryAddress.city',
              value: updatedContact.customer?.customerPrimaryAddress?.city,
            },
            {
              label: 'ZIP',
              field: 'customerPrimaryAddress.zip',
              value: updatedContact.customer?.customerPrimaryAddress?.zip,
            },
            {
              label: 'EMAIL',
              field: 'emailId',
              value: updatedContact.customer?.emailId,
              required: true,
            },
            {
              label: 'CUSTOMER ID',
              field: 'id',
              value: updatedContact.id,
            },
            {
              label: 'SCREEN POP URL',
              field: 'screenPopURL',
              value: updatedContact.screenPopURL,
            },
            // Only show MESSAGE TYPE and QUEUE NAME if media === 'Voice'
            {
              label: 'MESSAGE TYPE',
              field: 'messageType',
              value: updatedContact.messageType,
            },
            {
              label: 'QUEUE NAME',
              field: 'queueName',
              value: updatedContact.queueName,
            },
          ]
            .filter(
              ({ field }) =>
                // Only show messageType and queueName if media === 'Voice'
                !['messageType', 'queueName'].includes(field) ||
                updatedContact.media === 'Voice'
            )
            .map(({ label, field, value, required }) => (
              <CcfBox className={styles.containerGrid} key={field}>
                <CcfTypography className={styles.inputLabel}>
                  {label}{' '}
                  {required && <span style={{ color: '#C2041A' }}>*</span>}
                </CcfTypography>
                <CcfTextField
                  id={`sm_${field}`}
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '4px',
                      height: '36px',
                      border: '1px solid #AFC1CE',
                    },
                  }}
                  value={value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(field, event.target.value)
                  }
                  {...(field === 'emailId'
                    ? {
                        error:
                          !!value &&
                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                            value
                          ),
                        helperText:
                          !!value &&
                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                            value
                          )
                            ? 'Invalid email address'
                            : '',
                      }
                    : {})}
                />
              </CcfBox>
            ))}

          {updatedContact.media === 'Digital' &&
            updatedContact.channel === 'Email' && (
              <CcfBox className={styles.containerGrid}>
                <CcfTypography className={styles.inputLabel}>
                  REPLY WITH APPROVAL
                </CcfTypography>
                <DropDown
                  {...{
                    currentValue:
                      updatedContact.customer.replywithApproval || '',
                    field: 'replywithApproval',
                    label: '',
                    options: ['Yes', 'No'],
                    handleInputChange,
                    id: `sm_customerDetails_replywithApproval_${updatedContact.customer.replywithApproval}`,
                    stackName: 'customerDetails_replywithApproval',
                    selectInputStyle: {
                      borderRadius: '4px',
                      border: '1px solid #c4c4c4',
                      height: '36px',
                    },
                    selectRootStyle: {
                      padding: '10px',
                      fontSize: '1rem',
                    },
                  }}
                />
              </CcfBox>
            )}

          {updatedContact.media !== 'Digital' && (
            <>
              {[
                {
                  label: 'SCREEN POP PREFERENCE',
                  field: 'screenPopPreference',
                  options: ['Off', 'New Tab', 'External Window'],
                },
                {
                  label: 'CONTACT STATUS',
                  field: 'contactStatus',
                  options: ['ringing', 'on hold', 'conference'],
                },
                {
                  label: 'RTA STATUS',
                  field: 'rtaStatus',
                  options: [
                    'Authenticated',
                    'Missing Patron ID',
                    'Not Authenticated',
                  ],
                },
                {
                  label: 'AGENT ASSIST STATUS',
                  field: 'agentAssistStatus',
                  options: [
                    'Negative Score',
                    'Intermediate Score',
                    'Positive Score',
                  ],
                },
              ].map(({ label, field, options }) => (
                <CcfBox className={styles.containerGrid} key={field}>
                  <CcfTypography className={styles.inputLabel}>
                    {label}
                  </CcfTypography>
                  <DropDown
                    {...{
                      currentValue: updatedContact[field] || '',
                      field,
                      label: '',
                      options,
                      handleInputChange,
                      id: `sm_contactDetails_${field}_${updatedContact[field]}`,
                      stackName: `contactDetails_${field}`,
                      selectInputStyle: {
                        borderRadius: '4px',
                        border: '1px solid #c4c4c4',
                        height: '36px',
                      },
                      selectRootStyle: {
                        padding: '10px',
                        fontSize: '1rem',
                      },
                    }}
                  />
                </CcfBox>
              ))}
            </>
          )}
          {(updatedContact.media === 'Voice' ||
            (updatedContact.media === 'Digital' &&
              updatedContact.channel === 'Chat')) && (
            <CcfBox
              className={styles.containerGrid}
              sx={{ marginBottom: '0rem' }}
            >
              <CcfTypography className={styles.inputLabel}>
                AUTO SUMMARY
              </CcfTypography>
              <DropDown
                {...{
                  currentValue: updatedContact.autoSummary || '',
                  field: 'autoSummary',
                  label: '',
                  options: ['Off', 'On', 'Custom'],
                  handleInputChange,
                  id: `sm_customerDetails_autoSummary_${updatedContact.autoSummary}`,
                  stackName: 'customerDetails_autoSummary',
                  selectInputStyle: {
                    borderRadius: '4px',
                    border: '1px solid #c4c4c4',
                    height: '36px',
                  },
                  selectRootStyle: {
                    padding: '10px',
                    fontSize: '1rem',
                  },
                }}
              />
            </CcfBox>
          )}
          {updatedContact.autoSummary === 'Custom' && (
            <CcfBox className={styles.containerGrid}>
              <CcfTypography className={styles.inputLabel}>
                AUTOSUMMARY TEXT
              </CcfTypography>
              <textarea
                id="sm_customerDetails_autoSummaryText"
                className={styles.autoSummary_textarea}
                value={updatedContact.autoSummaryText || ''}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                  handleInputChange('autoSummaryText', event.target.value)
                }
              ></textarea>
            </CcfBox>
          )}
        </CcfBox>
      </CcfBox>
    </div>
  );
}

export default SimulatorV2CustomerDetailsTab;
